import { ApolloClient, ApolloLink, HttpLink, InMemoryCache, gql, fromPromise } from '@apollo/client';
import { GraphQLWsLink } from '@apollo/client/link/subscriptions';
import { RetryLink } from '@apollo/client/link/retry';
import { onError } from '@apollo/client/link/error';
import { getMainDefinition } from '@apollo/client/utilities';
import { createClient } from 'graphql-ws';
import { jwtDecode } from 'jwt-decode';
import * as Sentry from '@sentry/react';
import { ONE_MILLI_SECOND } from './constants';
let refreshingTokenPromise = null;
let isRefreshing = false;
let pendingRequests = [];
const getNewAccessToken = async () => {
    // if (refreshingTokenPromise) {
    //     // Return the promise of the existing refresh token request
    //     return refreshingTokenPromise;
    // }

    const GET_TOKEN_QUERY = gql`
        mutation ($body: RefreshTokenInput!) {
            generateNewAccessToken(body: $body) {
                accessToken
                refreshToken
            }
        }
    `;

    const refreshtoken = localStorage.getItem('diologRefToken');

    if (!refreshtoken) {
        return false;
    }
    try {
        const { data } = await client.mutate({
            mutation: GET_TOKEN_QUERY,
            variables: {
                body: { refreshtoken }
            }
        });
        // .then((response) => {
        //     //  console.log('====response', response);
        //     const { accessToken, refreshToken } = response.data.generateNewAccessToken;
        //     localStorage.setItem('diologAuthToken', accessToken);
        //     localStorage.setItem('diologRefToken', refreshToken);
        //     refreshingTokenPromise = null; // Reset the refreshing token promise
        //     return accessToken;
        // })
        // .catch((error) => {
        //     refreshingTokenPromise = null; // Reset the refreshing token promise
        //     localStorage.clear();
        //     window.location.replace('/');
        //     throw error;
        // });
        refreshingTokenPromise = null;
        const { accessToken, refreshToken } = data.generateNewAccessToken;
        localStorage.setItem('diologAuthToken', accessToken);
        localStorage.setItem('diologRefToken', refreshToken);
        return accessToken;
    } catch (e) {
        refreshingTokenPromise = null;
        localStorage.clear();
        window.location.replace('/');
        throw e;
    }
    // return refreshingTokenPromise;
};

// const getTokenExpiry = (token) => {
//     const decodedToken = jwtDecode(token);
//     return decodedToken.exp * ONE_MILLI_SECOND;
// };

// const shouldRefreshToken = (expiryTime) => {
//     // Set a buffer time before expiry to initiate refresh (e.g., 1 minute before expiry)
//     const bufferTime = expiryTime - Math.round(expiryTime / 2);
//     const now = Date.now();
//     return expiryTime - now <= bufferTime;
// };

// const checkAndRefreshToken = () => {
//     const accessToken = localStorage.getItem('diologAuthToken');
//     if (!accessToken) {
//         return;
//     }

//     const expiryTime = getTokenExpiry(accessToken);
//     if (shouldRefreshToken(expiryTime)) {
//         // Refresh the token
//         getNewAccessToken();
//     }
// };

// Periodically check and refresh token every minute
// setInterval(checkAndRefreshToken, ONE_MILLI_SECOND);

const errorLink = onError(({ graphQLErrors, networkError, operation, forward }) => {
    if (graphQLErrors) {
        for (let err of graphQLErrors) {
            // Log GraphQL errors to Sentry
            Sentry.captureException(new Error(`GraphQL Error: ${err.message}`), {
                tags: {
                    type: 'graphql_error',
                    operation: operation.operationName
                },
                extra: {
                    graphqlError: {
                        message: err.message,
                        code: err.extensions?.code,
                        path: err.path
                    },
                    operation: {
                        name: operation.operationName,
                        type: operation.query?.definitions?.[0]?.operation
                    },
                    variables: operation.variables ? Object.keys(operation.variables) : []
                },
                level: err.extensions?.code === 'UNAUTHENTICATED' ? 'info' : 'error'
            });

            switch (err?.extensions?.code) {
                case 'UNAUTHENTICATED':
                    // Check if a refresh token request is already in progress
                    if (!refreshingTokenPromise) {
                        // Initiate a new refresh token request
                        refreshingTokenPromise = getNewAccessToken();
                    }

                    // Return the promise of the existing refresh token request
                    return fromPromise(
                        refreshingTokenPromise.then((accessToken) => {
                            // Update the operation context with the new token
                            operation.setContext({
                                headers: {
                                    authorization: accessToken
                                }
                            });
                            //refreshingTokenPromise = null; // Reset the refreshing token promise
                            return forward(operation);
                        })
                    );

                default:
                    break;
            }
        }
    }

    if (networkError) {
        console.log(`[Network error]: ${networkError}`);
        // Log network errors to Sentry
        Sentry.captureException(networkError, {
            tags: {
                type: 'network_error',
                operation: operation.operationName
            },
            extra: {
                operation: {
                    name: operation.operationName,
                    type: operation.query?.definitions?.[0]?.operation
                },
                networkError: {
                    name: networkError.name,
                    message: networkError.message,
                    statusCode: networkError.statusCode
                }
            }
        });
    }
});
// const resolvePendingRequests = () => {
//     pendingRequests.map((callback) => callback());
//     pendingRequests = [];
// };
// const addPendingRequest = (pendingRequest) => {
//     pendingRequests.push(pendingRequest);
// };
// const errorLink = onError(({ graphQLErrors, operation, forward }) => {
//     if (graphQLErrors) {
//         for (const err of graphQLErrors) {
//             switch (err?.message) {
//                 case 'Unauthorized':
//                     if (!isRefreshing) {
//                         isRefreshing = true;

//                         return fromPromise(
//                             getNewAccessToken().catch(() => {
//                                 resolvePendingRequests();
//                                 isRefreshing = false;

//                                 localStorage.clear();

//                                 // Cache shared with main client instance

//                                 return forward(operation);
//                             })
//                         ).flatMap(() => {
//                             resolvePendingRequests();
//                             isRefreshing = false;
//                             return forward(operation);
//                         });
//                     } else {
//                         return fromPromise(
//                             new Promise((resolve) => {
//                                 addPendingRequest(() => resolve());
//                             })
//                         ).flatMap(() => {
//                             return forward(operation);
//                         });
//                     }
//             }
//         }
//     }
// });

// const errorLink = onError(({ graphQLErrors, networkError, forward, operation }) => {
//     if (graphQLErrors) {
//         for (const err of graphQLErrors) {
//             switch (err?.message) {
//                 case 'Unauthorized':
//                     operation.setContext(async ({ headers = {} }) => {
//                         try {
//                             const token = await getNewAccessToken();
//                             // optionally you can save in storage and let retryLink call the authLink again
//                             return {
//                                 headers: {
//                                     ...headers,
//                                     Authorization: token ? `${token}` : ''
//                                 }
//                             };
//                         } catch (e) {
//                             localStorage.clear();
//                             window.location.replace('/');
//                         }
//                     });

//                     return forward(operation);
//                 default:
//                     break;
//             }
//         }
//     }
//     if (networkError) {
//         console.log(`[Network error]: ${networkError}`);
//     }
// });

// const errorLink = onError(({ graphQLErrors, operation, forward }) => {
//     if (graphQLErrors) {
//         if (graphQLErrors.some(({ extensions: { code } }) => ['UNAUTHENTICATED'].includes(code))) {
//             return fromPromise(getNewAccessToken()).flatMap(() => forward(operation));
//         }
//     }
//     return forward(operation);
// });

// const getNewAccessToken = () => {
//     const GET_TOKEN_QUERY = gql`
//         mutation ($body: RefreshTokenInput!) {
//             generateNewAccessToken(body: $body) {
//                 accesstoken
//                 accessTokenExpiresIn
//             }
//         }
//     `;

//     const refreshtoken = localStorage.getItem('diologRefToken');
//     // console.log({ refreshtoken });
//     // if (!refreshtoken) {
//     //     return Promise.reject(new Error('No refresh token available'));
//     // }

//     if (refreshtoken) {
//         return client
//             .mutate({
//                 mutation: GET_TOKEN_QUERY,
//                 variables: {
//                     body: {
//                         refreshtoken
//                     }
//                 }
//                 // context: {
//                 //   headers: {
//                 //     Authorization: refreshtoken || null,
//                 //   },
//                 // },
//             })
//             .then((response) => {
//                 // extract your accessToken from your response data and return it
//                 const { accessToken,refreshToken } = response.data.generateNewAccessToken;
//                 localStorage.setItem('diologAuthToken', accessToken);
//                 localStorage.setItem('diologRefToken',refreshToken)
//                 return accessToken;
//             })
//             .catch((error) => {
//                 localStorage.clear();
//                 window.location.replace('/');
//                 // navigate('login', { replace: true });
//                 throw error;
//             });
//     }

//     return false;
// };

const authMiddleware = new ApolloLink((operation, forward) => {
    const extToken = operation.getContext().extToken;
    const accessToken = localStorage.getItem('diologAuthToken');

    if (extToken) {
        operation.setContext({
            headers: {
                authorization: extToken
            }
        });
    } else {
        if (accessToken) {
            operation.setContext({
                headers: {
                    authorization: accessToken
                }
            });
        }
    }

    return forward(operation);
});

// Sentry performance monitoring middleware for GraphQL operations
const sentryMiddleware = new ApolloLink((operation, forward) => {
    const operationName = operation.operationName || 'UnnamedOperation';
    const operationType = operation.query?.definitions?.[0]?.operation || 'unknown';
    const startTime = Date.now();

    return forward(operation).map((result) => {
        const duration = Date.now() - startTime;
        // Add breadcrumb for GraphQL operations
        Sentry.addBreadcrumb({
            category: 'graphql',
            message: `GraphQL ${operationType}: ${operationName}`,
            level: result.errors && result.errors.length > 0 ? 'error' : 'info',
            data: {
                operationName,
                operationType,
                duration,
                hasErrors: result.errors && result.errors.length > 0,
                errorCount: result.errors ? result.errors.length : 0
            }
        });

        // Create span for performance monitoring
        Sentry.withScope((scope) => {
            scope.setTag('graphql.operation.name', operationName);
            scope.setTag('graphql.operation.type', operationType);
            scope.setLevel(result.errors && result.errors.length > 0 ? 'error' : 'info');
            scope.setContext('graphql', {
                operationName,
                operationType,
                duration,
                variableKeys: operation.variables ? Object.keys(operation.variables) : [],
                hasErrors: result.errors && result.errors.length > 0,
                errorCount: result.errors ? result.errors.length : 0
            });
        });

        return result;
    });
});

// export function setAuthenticationHeaderForWs() {
//     const token = localStorage.getItem('diologAuthToken');
//     const authLink = setContext((_, _) => {
//         return {
//             connectionParams: {
//                 Authorization: token || null
//             }
//         };
//     });

//     config.setLink(authLink.concat(httpLink));
// }

// const errorLink = onError(({ graphQLErrors, networkError, operation, forward }) => {
//     if (graphQLErrors) {
//         for (let err of graphQLErrors) {
//             switch (err?.extensions?.code) {
//                 // Apollo Server sets code to UNAUTHENTICATED
//                 // when an AuthenticationError is thrown in a resolver
//                 case 'UNAUTHENTICATED':
//                     // Modify the operation context with a new token
//                     return fromPromise(
//                         getNewAccessToken().then((accessToken) => {
//                             operation.setContext({
//                                 headers: {
//                                     authorization: getNewAccessToken()
//                                 }
//                             });
//                             return forward(operation);
//                         })
//                     );

//                 // Retry the request, returning the new observable
//                 default:
//                     break;
//             }
//         }
//     }

//     // To retry on network errors, we recommend the RetryLink
//     // instead of the onError link. This just logs the error.
//     if (networkError) {
//         console.log(`[Network error]: ${networkError}`);
//     }
// });

const httpLink = new HttpLink({
    uri: process.env.REACT_APP_API_BASE_URL
});

const wsLink = new GraphQLWsLink(
    createClient({
        url: process.env.REACT_APP_WEBSOCKET_BASE_URL,
        keepAlive: 60,
        shouldRetry: true,
        connectionParams: () => {
            const token = localStorage.getItem('diologAuthToken') || '';
            return { Authorization: token };
        }
        // () => {
        //     // Here, you can provide authorization headers if available
        //     const token = localStorage.getItem('diologAuthToken');
        //     return {
        //         headers: {
        //             Authorization: token ? `${token}` : ''
        //         }
        //     };
        // }
    })
);
const retryLink = new RetryLink();

function splitByOperation({ query }) {
    const definition = getMainDefinition(query);
    return definition.kind === 'OperationDefinition' && definition.operation === 'subscription';
}

const link = ApolloLink.from([
    errorLink,
    retryLink,
    sentryMiddleware,
    authMiddleware,
    ApolloLink.split(
        // split based on operation type
        splitByOperation,
        wsLink,
        httpLink
    )
]);

let client = new ApolloClient({
    cache: new InMemoryCache(),
    link: link,
    name: 'DiologAdmin',
    version: '1.1'
});

client.defaultOptions = {
    watchQuery: {
        fetchPolicy: 'network-only', // Used for first execution
        nextFetchPolicy: 'cache-first',
        errorPolicy: 'ignore'
    },
    query: {
        fetchPolicy: 'network-only', // Used for first execution
        nextFetchPolicy: 'cache-first',
        errorPolicy: 'all'
    }
};

export default client;
